import React from 'react';

const Tabs = ({
  tabs = [],
  selectedTab = 0,
  onTabChange = () => {},
  className = '',
  tabClassName = '',
  activeTabClassName = '',
  inactiveTabClassName = '',
  maxWidth,
}) => {
  const defaultContainerClass =
    'bg-light-bg max-w-3xl flex-1 py-2 lg:py-0 lg:h-14 flex flex-wrap px-3 sm:justify-between items-center gap-2 rounded-md';
  const defaultTabClass =
    'shadow-none font-averta border-none text-sm sm:text-base hover:shadow-md transition-all font-bold px-2 lg:px-4 h-9 rounded-md whitespace-nowrap inline-block cursor-pointer';
  const defaultActiveClass = 'text-primary-text bg-white';
  const defaultInactiveClass = 'text-inactive-text bg-transparent';

  return (
    <div
      className={`${defaultContainerClass} ${className}`}
      style={{ maxWidth }}>
      {tabs.map((tab, index) => (
        <button
          className={`${defaultTabClass} ${tabClassName} ${
            selectedTab === index
              ? `${defaultActiveClass} ${activeTabClassName}`
              : `${defaultInactiveClass} ${inactiveTabClassName}`
          }`}
          onClick={() => onTabChange(index)}
          key={index}>
          {tab.title || tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
